import React from "react";
import { SelectInput } from "../../lib";

const AttendanceInput = ({ onChange, autoFocus, ...rest }) => {
  return (
    <SelectInput
      {...rest}
      className="AttendanceInput"
      autoFocus
      onChange={v => onChange(v, true)}
    >
      <option disabled selected hidden>
        Please choose...
      </option>
      {["Under 200", "200-499", "500-999", "1,000-4,999", "5,000+"].map(
        role => (
          <option value={role} key={role}>
            {role}
          </option>
        )
      )}
    </SelectInput>
  );
};

AttendanceInput.displayName = "AttendanceInput";

export default AttendanceInput;



// WEBPACK FOOTER //
// ./src/assess/question/AttendanceInput.js